import React from 'react'

function ErrorPage404() {
  return (
    <div className='justify-center h-screen flex-col flex items-center'>
      <h3>404 PAGE NOT FOUND</h3>
    </div>
  )
}

export default ErrorPage404
